var map = {
	"./app_strings.json": 45399,
	"./client/account_client.json": 36138,
	"./client/common_client.json": 30098,
	"./client/console.json": 17714,
	"./client/consultation_client.json": 77170,
	"./client/eyes.json": 29871,
	"./client/nav_client.json": 54300,
	"./client/patient_client.json": 6672,
	"./client/pdf.json": 533,
	"./client/stats_client.json": 56634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82280;